import { render, staticRenderFns } from "./EntityList.vue?vue&type=template&id=35dc26d4&scoped=true&"
import script from "./EntityList.vue?vue&type=script&lang=js&"
export * from "./EntityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc26d4",
  null
  
)

export default component.exports